






























import { namespace } from 'vuex-class';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { CART } from '@/store/types';
import PageCartItem from './PageCartItem.vue';
import { ApiService } from '@/services/ApiService';
import { ConfigService } from '@/services/ConfigService';
import { BestFriendOpenOrderApi } from '@eurogast/hub-client-typescript';
import ConfirmationActionButton from '@/common/ConfirmationActionButton.vue';
import PromotedProductCartItem from '@/cart-page/cart/section/PromotedProductCartItem.vue';

const cart = namespace(CART);

@Component({
  components: {PageCartItem, ConfirmationActionButton, PromotedProductCartItem}
})
export default class BestFriendSection extends Vue {

  @Prop({required: false, default: false})
  public showBestFriendMenu: boolean;

  private bfApi = ApiService.wrap(BestFriendOpenOrderApi);
  private bfOrderCount = 0;

  public mounted() {
    if (this.showBestFriendMenu) {
      this.bfApi.getAllBestFriendOrders(ConfigService.getTenant(), ConfigService.currentCustomerId)
          .then((result) => this.bfOrderCount = result.length)
          .catch(ApiService.defaultErrorHandler);
    }

  }
}
